/* WKS custom — mobiel menu (< 768px), vanilla JS */
(function () {
  'use strict';

  var root = document.querySelector('[data-wks-mnav]');
  if (!root) return;

  var mq = window.matchMedia('(max-width: 767px)');
  var panel = root.querySelector('.wks-mnav__panel');
  var closeEls = root.querySelectorAll('[data-wks-close]');
  var closeBtn = root.querySelector('.wks-mnav__close');
  var accBtns = root.querySelectorAll('[data-wks-acc]');
  var isOpen = false;
  var savedScroll = 0;
  var savedLabel = null;

  function burger() {
    return document.querySelector('.mobileMenu-toggle, [data-mobile-menu]');
  }

  function setBurgerAria() {
    var b = burger();
    if (!b) return;
    if (mq.matches) {
      if (savedLabel === null) savedLabel = b.getAttribute('aria-label') || '';
      b.setAttribute('aria-label', 'Menu openen');
      b.setAttribute('aria-controls', 'wks-mobile-nav');
      b.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    } else if (savedLabel !== null) {
      b.setAttribute('aria-label', savedLabel);
      b.removeAttribute('aria-controls');
      b.removeAttribute('aria-expanded');
    }
  }

  function openNav() {
    if (isOpen) return;
    isOpen = true;
    savedScroll = window.pageYOffset || 0;
    document.body.style.top = -savedScroll + 'px';
    document.body.classList.add('wks-mnav-lock');
    root.classList.add('is-open');
    setBurgerAria();
    if (closeBtn) closeBtn.focus();
  }

  function closeNav(focusBurger) {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    document.body.classList.remove('wks-mnav-lock');
    document.body.style.top = '';
    window.scrollTo(0, savedScroll);
    setBurgerAria();
    var b = burger();
    if (focusBurger && b) b.focus();
  }

  /* hamburger overnemen via capture-fase */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.mobileMenu-toggle, [data-mobile-menu]') : null;
    if (!t || !mq.matches) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    openNav();
  }, true);

  for (var i = 0; i < closeEls.length; i++) {
    closeEls[i].addEventListener('click', function () { closeNav(true); });
  }

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      closeNav(true);
      return;
    }
    if (e.key !== 'Tab') return;
    var nodes = panel.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden])');
    var vis = [];
    for (var j = 0; j < nodes.length; j++) {
      if (nodes[j].offsetParent !== null) vis.push(nodes[j]);
    }
    if (!vis.length) return;
    var first = vis[0];
    var last = vis[vis.length - 1];
    if (!panel.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }, true);

  /* Accordeons: max 1 open */
  function setAcc(btn, on) {
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    var wrap = btn.closest('.wks-acc');
    if (wrap) wrap.classList.toggle('is-open', on);
  }
  for (var k = 0; k < accBtns.length; k++) {
    accBtns[k].addEventListener('click', function () {
      var wasOpen = this.getAttribute('aria-expanded') === 'true';
      for (var m = 0; m < accBtns.length; m++) setAcc(accBtns[m], false);
      if (!wasOpen) setAcc(this, true);
    });
  }

  /* Boven 767px: sluiten en originele aria terugzetten */
  function onRangeChange() {
    if (!mq.matches) closeNav(false);
    setBurgerAria();
  }
  if (mq.addEventListener) { mq.addEventListener('change', onRangeChange); }
  else if (mq.addListener) { mq.addListener(onRangeChange); }

  /* na navigatie/bfcache dicht */
  window.addEventListener('pageshow', function () { closeNav(false); });

  setBurgerAria();
})();
